import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

/**
 * Same Firebase project as voyp-webapp — the admin console authenticates the
 * same accounts, it just talks to /api/admin/* instead of /api/*.
 *
 * The web config is not a secret (it identifies the project, it does not grant
 * access), which is why it lives in source here as it does in voyp-webapp.
 *
 * Deliberately omitted vs. voyp-webapp: App Check (the server never verifies
 * App Check tokens), Analytics, Storage, Messaging and Remote Config — the
 * admin console needs none of them, and the API base URL comes straight from
 * VITE_API_BASE rather than through Remote Config.
 */
export const firebaseConfig = {
  apiKey: 'AIzaSyChDn6iMGrnRqaemIRKq6QobdboHHmGjEw',
  authDomain: 'voyp-278bf.firebaseapp.com',
  projectId: 'voyp-278bf',
  storageBucket: 'voyp-278bf.appspot.com',
  messagingSenderId: '403888540913',
  appId: '1:403888540913:web:087653ed4b9f2b7547ed50',
  measurementId: 'G-8ZQZ1RV86Y',
}

export const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)

export const googleProvider = new GoogleAuthProvider()
